document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        // Initialt dölja svaret
        answer.style.maxHeight = '0';

        question.addEventListener('click', () => {
            // Fäll ihop alla andra svar
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.faq-answer').style.maxHeight = '0';
                }
            });

            // Växla den aktuella FAQ-itemen
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                answer.style.maxHeight = '0';
            } else {
                item.classList.add('active');
                answer.style.maxHeight = answer.scrollHeight + "px"; // Gör så att svaret expanderar dynamiskt
            }
        });
    });
});